<template>
    <div v-if="model.entity.length" :id="'rightPanel' + model.entity" class="panel rightPanel">
        <div class="panel-heading">
            <h3 class="panel-title rightPanelName" v-html="model.title"></h3>
            <div class="dropdown user-settings pull-right" role="menu">
                <!-- Canel Button -->
                <button v-if="model.entity=='company'"  @click.stop="cancel()" class="panelSubmit btn btn-danger btn-sm">
                    <i class="icon" :class="{ 'icon-cancel': !saving, 'icon-tick': saving}"></i>
                    <span>{{ saving ? 'Cancelling' : 'Cancel Company'}}</span>
                </button>
                <!-- Save Button -->
                <button v-if="show('save')" @click.stop="submit()" class="panelSubmit btn btn-success btn-sm">
                    <i class="icon" :class="{ 'icon-save': !saving, 'icon-tick': saving}"></i>
                    <span>{{ saving ? 'Saving' : 'Save'}}</span>
                </button>
                <!-- Cog Settings -->
                <a v-if="show('settings')"  href="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                    <span class="panel-controls"><i class="icon icon-settings"></i></span>
                </a>
                <ul class="dropdown-menu alert-dropdown" id="rightPanelDropdownMenu">
                    <li><a id="delete-btn" @click="deleteEntity()">Delete</a></li>
                    <li><a @click="takeOwnership()">Take Ownership of Entity</a></li>
                </ul>
                <!-- Close Right Panel -->
                <a @click.prevent="closePanel()">
                    <span class="panel-controls"><i class="icon icon-close"></i></span>
                </a>
            </div>
        </div>
        <div class="panel-body wide">
            <snapshot v-show="model.entity != 'allcomments'" :data="model"></snapshot>
            <div id="right-content" class="panel-content">
                <div :id="panelID" v-if="model.html" v-html="model.html"></div>
                <component :name="name" v-else v-bind:is="model.entity" panelType="right"></component>
            </div>
        </div>
    </div>
</template>
<script>
    let defaultModel = {
        panelID: 0,
        entityuser: { name: '' },
        entity: '',
        public_id: '',
        title: '',
        heading: '',
        html: false,
        tags: [],
        disable: {
            settings: false,
            save: false,
            tags: false,
            comments: false
        },
        user: false,
        comments: false,
        comment: ''
    };
    // == Default Model Vars for resetting purposes == //
    export default {
        data: function() {
            return {
                name: 'rightPanel.' + this.uniqueid(),
                saving: false,
                comment: '',
                model: {}
            }
        },
        created() {
            this.model = jQuery.extend(true, {}, defaultModel);
            this.$eventHub.$on('saving' + this.name, this.updateSaving);
            this.$eventHub.$on('setRightPanel', this.setRightPanel);
            this.$eventHub.$on('updateHeading', this.updateHeading);
            this.$eventHub.$on('closeRightPanel', this.closePanel);
        },
        methods: {
            updateSaving(saving) {
                this.saving = saving;
                this.$root.toggleLoader(saving);
            },
            show(type) {
                return !(typeof this.model.disable[type] !== 'undefined' && this.model.disable[type]);
            },
            closePanel(callback) {
                this.model.entity = '';
                this.$root.currentLocation = '';
                $('.ajaxActive').removeClass('ajaxActive');
                if (typeof callback === 'function') {
                    callback();
                }
            },
            submit(){
                this.$eventHub.$emit(this.model.entity + 'Submit');
            },
            updateHeading(name, heading) {
                if (this.name !== name) return;
                this.model.heading = heading;
            },
            setRightPanel(data) {
                window.BOLD.ajaxFormIsChanged = false;
                this.panelID = this.uniqueid();
                $('#view-col .panel .panel-body').scrollTop(0);
                this.model.comment = '';
                this.saving = false;
                $.each(this.model, (key, value) => {
                    let val = '';
                    if (typeof defaultModel[key] !== 'undefined') {
                        val = defaultModel[key];
                    }
                    if (typeof data[key] !== 'undefined') {
                        val = data[key];
                    }
                    this.model[key] = val;
                });
                // Loop through each event
                this.$nextTick(function () { // Runs after content is updated
                    if (this.model.html) {
                        remoteHacking(this.model.public_id, this.panelID);
                    }
                    this.$root.pushEvents(data.events);
                    setLoaderSize();
                });
            },
            takeOwnership() {
                this.axios.post('/api/take-ownership', {
                    id: this.model.public_id,
                    entity: this.model.entity
                }).then((response) => {
                    if (typeof response.data !== 'undefined' && typeof response.data.entityUser !== 'undefined') {
                        this.model.entityuser = response.data.entityUser;
                        this.$eventHub.$emit('updateOwner', this.model);
                    }
                });
            },
            deleteEntity() {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You can not un-do this action.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#33C7A5',
                    cancelButtonColor: '#00ADD3',
                    confirmButtonText: 'Yes, I am sure',
                }).then(() => {
                    this.$store('/api/' + this.model.entity + '/delete', {
                        id: this.model.public_id
                    }).then((response) => {
                        //location.pathname
                        if (typeof window.currentCompany.url !== 'undefined' && window.currentCompany.url != '') {
                            history.replaceState({url: window.currentCompany.url}, "Company View", window.currentCompany.url);
                        }
                    });
                });
            },
            cancel() {
                Swal.fire({
                    title: "Are you sure you want to cancel this company?",
                    html: `
                        <textarea id="cancel-comments" cols="40" class="swal2-textarea" placeholder="Enter comments"></textarea>
                        <input type="number" style="width:187px;" id="cancel-website-no" class="swal2-input" placeholder="No of websites">
                    `,
                    focusConfirm: false,
                    showCancelButton: true,
                    preConfirm: () => {
                        return [
                        document.getElementById("cancel-comments").value,
                        document.getElementById("cancel-website-no").value
                        ];
                    },
                    confirmButtonColor: "#46c37b",
                    cancelButtonColor: "#00ADD3",
                    confirmButtonText: "Yes, cancel"
                }).then((data) => {
                    console.log(data.value[0]);
                    this.$store('/api/' + this.model.entity + '/cancel', {
                        id: this.model.public_id,
                        comments: data.value[0],
                        website_no: data.value[1],
                    }).then((response) => {
                    //     //location.pathname
                        if (typeof window.currentCompany.url !== 'undefined' && window.currentCompany.url != '') {
                            history.replaceState({url: window.currentCompany.url}, "Company View", window.currentCompany.url);
                        }
                    });
                });
            }
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('saving' + this.name, this.updateSaving);
            this.$eventHub.$off('setRightPanel', this.setRightPanel);
            this.$eventHub.$off('closeRightPanel', this.closePanel);
            this.$eventHub.$off('updateHeading', this.updateHeading);
        },
        components: {
            'snapshot':             require('./snapshot.vue').default,
            'list':             require('../components/form/list.vue').default,
            'txt':              require('../components/form/text.vue').default,
            'InputTag':         require('../components/InputTag.vue').default,
            'company':          require('./company/company-form.vue').default,
            'proposal':          require('./proposal/html-form.vue').default,
            'renewal':          require('./invoice/renewal-form.vue').default,
            'contact':          require('./contact/contact-form.vue').default,
            'address-form':     require('./address-form.vue').default,
            'payment':          require('./payment/payment-form.vue').default,
            'email':            require('./email/email-form.vue').default,
            'taxrate':            require('./tax/tax-form.vue').default,
            'emailaccount':     require('./email/emailaccount-form.vue').default,
            'server':           require('./server-form.vue').default,
            'website':          require('./website/website-form.vue').default,
            'awswebsite':          require('./website/aws-website-form.vue').default,
            'domain':           require('./domain/domain.vue').default,
            'user':           require('./user-form.vue').default,
            'invoice':          require('./invoice/invoice-quick-form.vue').default,
            'emailtemplate':    require('./email/template/email-template-form.vue').default,
            'paymentgateways':  require('./gateway/payment-gateway-form.vue').default,
            'product':          require('./product/product-form.vue').default,
            'allcomments':      require('./all-comments.vue').default,
            'externallinks':      require('./links/links-form').default,
        }
    }
</script>
